import { FC, SyntheticEvent, useCallback, useState } from "react";
import { Box, TextField, IconButton, Tooltip, InputAdornment, SxProps, Theme } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';


const Search: FC<{ placeholder: string; sx?: SxProps<Theme> }> = ({ placeholder, sx }) => {
    const [ searchTerm, setSearchTerm ] = useState<string|undefined>();

    const handleSearch = useCallback((event: SyntheticEvent|KeyboardEvent, value: string|undefined) => {
        event.preventDefault();
        event.stopPropagation();
        if (event instanceof KeyboardEvent) {
            const target = event.target as HTMLInputElement;
            setSearchTerm(target.value);
        } else if (value) {
            setSearchTerm(value);
        }
    }, []);

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
    };

    const handleKeyPress = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter') {
            handleSearchSubmit();
        }
    };

    const handleSearchSubmit = () => {
        if (searchTerm) {
            // Perform search logic here
        }
    };

    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            width: '100%',
            maxWidth: '680px',
            minWidth: '200px',
            ...sx
        }}>
            <TextField
                placeholder={placeholder}
                value={searchTerm}
                onChange={handleSearchChange}
                onKeyPress={handleKeyPress}
                variant="outlined"
                size="small"
                sx={{ flexGrow: 1 }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon color="action" />
                        </InputAdornment>
                    ),
                }}
            />
        </Box>
    );
};

export default Search;
